
import { useState } from 'react';
import { Link } from 'react-router-dom';

const ProdutosPage = () => {
  const [activeCategory, setActiveCategory] = useState('new-in');

  const categories = [
    { id: 'new-in', name: 'New In', icon: 'ri-fire-line' },
    { id: 'camisas', name: 'Camisas', icon: 'ri-shirt-line' },
    { id: 'bermudas', name: 'Bermudas', icon: 'ri-shorts-line' },
    { id: 'conjuntos', name: 'Conjuntos', icon: 'ri-handbag-line' },
    { id: 'bags', name: 'Bags', icon: 'ri-briefcase-line' },
    { id: 'relogios', name: 'Relógios', icon: 'ri-time-line' },
    { id: 'acessorios', name: 'Acessórios', icon: 'ri-glasses-line' }
  ];

  const products = {
    'new-in': [
      {
        name: 'Camisa Hermès Exclusive',
        brand: 'Hermès',
        line: '1.1',
        image: 'https://public.readdy.ai/ai/img_res/54fb4b70a233e0e52e8da4e0de981019.jpg',
        description: 'Camisa Hermès 1.1 – seda francesa premium com acabamento artesanal exclusivo.',
        prices: {
          single: 'R$ 119',
          three: 'R$ 109',
          six: 'R$ 99',
          twelve: 'R$ 89'
        },
        badge: '🔥 Chegou Agora'
      },
      {
        name: 'Conjunto Dior Complete',
        brand: 'Dior',
        line: 'Premium',
        image: 'https://readdy.ai/api/search-image?query=luxury%20navy%20blue%20Dior%20complete%20outfit%20set%20on%20sophisticated%20tattooed%20male%20model%2C%20premium%20French%20fabric%20ensemble%20with%20textile%20texture%20details%2C%20elegant%20studio%20lighting%20with%20fabric%20focus%2C%20minimalist%20white%20background%2C%20high-end%20fashion%20photography%2C%20exclusive%20fabric%20commercial%20shoot&width=600&height=750&orientation=portrait',
        description: 'Conjunto Dior Premium – alfaiataria francesa com tecido de alta costura.',
        prices: {
          single: 'R$ 229',
          three: 'R$ 209',
          six: 'R$ 189',
          twelve: 'R$ 169'
        },
        badge: '🔥 Edição Limitada'
      }
    ],
    camisas: [
      {
        name: 'Camisa Prada Premium',
        brand: 'Prada',
        line: '1.1',
        code: 'PRA001',
        image: 'https://readdy.ai/api/search-image?query=luxury%20black%20Prada%20shirt%20on%20elegant%20male%20model%20with%20tattoos%2C%20premium%20Italian%20fabric%20texture%20visible%2C%20sophisticated%20studio%20lighting%20with%20fabric%20detail%20focus%2C%20minimalist%20white%20background%20with%20subtle%20textile%20shadows%2C%20high-end%20menswear%20photography%20style%2C%20professional%20commercial%20shoot&width=400&height=500&seq=prada-fabric-shirt-1&orientation=portrait',
        description: 'Camisa Prada 1.1 – tecido italiano, corte slim e acabamento invisível.',
        prices: {
          single: 'R$ 89',
          three: 'R$ 79',
          six: 'R$ 69',
          twelve: 'R$ 59'
        }
      },
      {
        name: 'Camisa Gucci Italiana',
        brand: 'Gucci',
        line: '1.2',
        code: 'GUC002',
        image: 'https://readdy.ai/api/search-image?query=luxury%20white%20Gucci%20dress%20shirt%20on%20tattooed%20male%20model%2C%20premium%20Italian%20cotton%20fabric%20texture%20close-up%2C%20elegant%20studio%20setup%20with%20fabric%20weave%20details%2C%20clean%20white%20background%20with%20professional%20lighting%2C%20high-end%20menswear%20photography%2C%20sophisticated%20textile%20commercial%20style&width=400&height=500&seq=gucci-fabric-shirt-2&orientation=portrait',
        description: 'Camisa Gucci 1.2 – linha italiana premium com detalhes exclusivos.',
        prices: {
          single: 'R$ 95',
          three: 'R$ 85',
          six: 'R$ 75',
          twelve: 'R$ 65'
        }
      },
      {
        name: 'Camisa Louis Vuitton',
        brand: 'Louis Vuitton',
        line: 'Premium',
        code: 'LV003',
        image: 'https://readdy.ai/api/search-image?query=luxury%20navy%20blue%20Louis%20Vuitton%20shirt%20on%20stylish%20tattooed%20male%20model%2C%20premium%20French%20cotton%20fabric%20texture%20details%2C%20sophisticated%20studio%20lighting%20with%20textile%20focus%2C%20minimalist%20white%20background%2C%20high-end%20fashion%20photography%2C%20professional%20fabric%20commercial%20shoot%20style&width=400&height=500&seq=lv-fabric-shirt-3&orientation=portrait',
        description: 'Camisa Louis Vuitton Premium — qualidade francesa com acabamento perfeito.',
        prices: {
          single: 'R$ 99',
          three: 'R$ 89',
          six: 'R$ 79',
          twelve: 'R$ 69'
        }
      }
    ],
    bermudas: [
      {
        name: 'Bermuda Versace Sport',
        brand: 'Versace',
        line: '1.1',
        code: 'VER004',
        image: 'https://readdy.ai/api/search-image?query=luxury%20black%20Versace%20shorts%20on%20athletic%20tattooed%20male%20model%2C%20premium%20sport%20fabric%20texture%20visible%2C%20dynamic%20studio%20lighting%20with%20textile%20detail%20focus%2C%20clean%20white%20background%2C%20high-end%20sportswear%20photography%20with%20fabric%20emphasis%2C%20professional%20commercial%20style&width=400&height=500&seq=versace-fabric-shorts-4&orientation=portrait',
        description: 'Bermuda Versace 1.1 – tecido esportivo premium com design italiano.',
        prices: {
          single: 'R$ 79',
          three: 'R$ 69',
          six: 'R$ 59',
          twelve: 'R$ 49'
        }
      },
      {
        name: 'Bermuda Hugo Boss',
        brand: 'Hugo Boss',
        line: '1.2',
        code: 'HB005',
        image: 'https://readdy.ai/api/search-image?query=luxury%20navy%20blue%20Hugo%20Boss%20shorts%20on%20sophisticated%20tattooed%20male%20model%2C%20premium%20German%20fabric%20texture%20close-up%2C%20elegant%20studio%20lighting%20with%20textile%20weave%20details%2C%20minimalist%20white%20background%2C%20high-end%20menswear%20photography%2C%20professional%20fabric%20commercial%20style&width=400&height=500&seq=hugoboss-fabric-shorts-5&orientation=portrait',
        description: 'Bermuda Hugo Boss 1.2 – alfaiataria alemã com tecido premium.',
        prices: {
          single: 'R$ 85',
          three: 'R$ 75',
          six: 'R$ 65',
          twelve: 'R$ 55'
        }
      }
    ],
    conjuntos: [
      {
        name: 'Conjunto Armani Complete',
        brand: 'Armani',
        line: 'Premium',
        code: 'ARM005',
        image: 'https://readdy.ai/api/search-image?query=luxury%20gray%20Armani%20complete%20outfit%20set%20on%20elegant%20tattooed%20male%20model%2C%20premium%20Italian%20fabric%20ensemble%20with%20textile%20texture%20details%2C%20sophisticated%20studio%20lighting%20with%20fabric%20focus%2C%20minimalist%20white%20background%2C%20high-end%20fashion%20photography%2C%20professional%20fabric%20commercial%20shoot&width=600&height=750&seq=armani-fabric-set-5&orientation=portrait',
        description: 'Conjunto Armani Premium – camisa e calça em tecido italiano premium.',
        prices: {
          single: 'R$ 189',
          three: 'R$ 169',
          six: 'R$ 149',
          twelve: 'R$ 129'
        }
      },
      {
        name: 'Conjunto Tom Ford Elite',
        brand: 'Tom Ford',
        line: '1.1',
        code: 'TF006',
        image: 'https://readdy.ai/api/search-image?query=luxury%20black%20Tom%20Ford%20complete%20suit%20set%20on%20sophisticated%20tattooed%20male%20model%2C%20premium%20American%20fabric%20ensemble%20with%20textile%20texture%20details%2C%20elegant%20studio%20lighting%20with%20fabric%20focus%2C%20minimalist%20white%20background%2C%20high-end%20fashion%20photography%2C%20exclusive%20fabric%20commercial%20style&width=600&height=750&seq=tomford-fabric-set-6&orientation=portrait',
        description: 'Conjunto Tom Ford 1.1 – alfaiataria americana com tecidos exclusivos.',
        prices: {
          single: 'R$ 249',
          three: 'R$ 229',
          six: 'R$ 209',
          twelve: 'R$ 189'
        }
      }
    ],
    bags: [
      {
        name: 'Bag Louis Vuitton Keepall',
        brand: 'Louis Vuitton',
        line: '1.2',
        code: 'LVB007',
        image: 'https://readdy.ai/api/search-image?query=luxury%20brown%20Louis%20Vuitton%20Keepall%20bag%20held%20by%20tattooed%20male%20model%2C%20premium%20leather%20texture%20with%20fabric%20interior%20details%2C%20sophisticated%20studio%20lighting%20with%20textile%20focus%2C%20minimalist%20white%20background%2C%20high-end%20accessories%20photography%2C%20professional%20fabric%20commercial%20shoot&width=400&height=500&seq=lv-fabric-bag-7&orientation=portrait',
        description: 'Bag Louis Vuitton Keepall 1.2 – couro premium com monograma clássico.',
        prices: {
          single: 'R$ 199',
          three: 'R$ 179',
          six: 'R$ 159',
          twelve: 'R$ 139'
        }
      },
      {
        name: 'Bag Gucci Messenger',
        brand: 'Gucci',
        line: 'Premium',
        code: 'GUC008',
        image: 'https://readdy.ai/api/search-image?query=luxury%20black%20Gucci%20messenger%20bag%20on%20stylish%20tattooed%20male%20model%2C%20premium%20Italian%20leather%20texture%20with%20fabric%20lining%20details%2C%20sophisticated%20studio%20lighting%20with%20textile%20focus%2C%20minimalist%20white%20background%2C%20high-end%20accessories%20photography%2C%20professional%20fabric%20commercial%20style&width=400&height=500&seq=gucci-fabric-bag-8&orientation=portrait',
        description: 'Bag Gucci Messenger Premium – couro italiano com acabamento artesanal.',
        prices: {
          single: 'R$ 229',
          three: 'R$ 209',
          six: 'R$ 189',
          twelve: 'R$ 169'
        }
      }
    ],
    relogios: [
      {
        name: 'Relógio Rolex Submariner',
        brand: 'Rolex',
        line: '1.1',
        code: 'ROL006',
        image: 'https://readdy.ai/api/search-image?query=luxury%20black%20Rolex%20Submariner%20watch%20on%20tattooed%20male%20wrist%2C%20premium%20metal%20finish%20with%20fabric%20cuff%20detail%2C%20elegant%20studio%20lighting%20with%20textile%20background%2C%20clean%20white%20background%20with%20subtle%20fabric%20reflections%2C%20high-end%20watch%20photography%2C%20professional%20commercial%20style&width=400&height=500&seq=rolex-fabric-watch-6&orientation=portrait',
        description: 'Relógio Rolex Submariner 1.1 – movimento automático com acabamento suíço.',
        prices: {
          single: 'R$ 299',
          three: 'R$ 279',
          six: 'R$ 259',
          twelve: 'R$ 239'
        }
      },
      {
        name: 'Relógio Audemars Piguet',
        brand: 'Audemars Piguet',
        line: 'Premium',
        code: 'AP009',
        image: 'https://readdy.ai/api/search-image?query=luxury%20gold%20Audemars%20Piguet%20Royal%20Oak%20watch%20on%20sophisticated%20tattooed%20male%20wrist%2C%20premium%20metal%20finish%20with%20fabric%20sleeve%20detail%2C%20elegant%20studio%20lighting%20with%20textile%20background%2C%20minimalist%20white%20background%2C%20high-end%20watch%20photography%2C%20professional%20fabric%20commercial%20style&width=400&height=500&seq=ap-fabric-watch-9&orientation=portrait',
        description: 'Relógio Audemars Piguet Premium – Royal Oak com movimento suíço exclusivo.',
        prices: {
          single: 'R$ 399',
          three: 'R$ 379',
          six: 'R$ 359',
          twelve: 'R$ 339'
        }
      }
    ],
    acessorios: [
      {
        name: 'Óculos Ray-Ban Aviator',
        brand: 'Ray-Ban',
        line: 'Premium',
        code: 'RAY008',
        image: 'https://readdy.ai/api/search-image?query=luxury%20gold%20Ray-Ban%20Aviator%20sunglasses%20on%20stylish%20tattooed%20male%20model%2C%20premium%20metal%20frame%20with%20fabric%20clothing%20texture%20background%2C%20sophisticated%20studio%20lighting%20with%20textile%20details%2C%20clean%20white%20background%2C%20high-end%20eyewear%20photography%2C%20professional%20fabric%20commercial%20style&width=400&height=500&seq=rayban-fabric-glasses-8&orientation=portrait',
        description: 'Óculos Ray-Ban Aviator Premium – lentes polarizadas com armação dourada.',
        prices: {
          single: 'R$ 149',
          three: 'R$ 129',
          six: 'R$ 109',
          twelve: 'R$ 89'
        }
      },
      {
        name: 'Cinto Hermès Classic',
        brand: 'Hermès',
        line: '1.1',
        code: 'HER010',
        image: 'https://readdy.ai/api/search-image?query=luxury%20black%20Herm%C3%A8s%20leather%20belt%20on%20elegant%20tattooed%20male%20model%20waist%2C%20premium%20French%20leather%20texture%20with%20fabric%20clothing%20background%2C%20sophisticated%20studio%20lighting%20with%20textile%20details%2C%20minimalist%20white%20background%2C%20high-end%20accessories%20photography%2C%20professional%20fabric%20commercial%20style&width=400&height=500&seq=hermes-fabric-belt-10&orientation=portrait',
        description: 'Cinto Hermès Classic 1.1 – couro francês com fivela icônica.',
        prices: {
          single: 'R$ 179',
          three: 'R$ 159',
          six: 'R$ 139',
          twelve: 'R$ 119'
        }
      }
    ]
  };

  return (
    <div className="min-h-screen bg-black overflow-x-hidden" style={{ fontFamily: 'Manrope, sans-serif' }}>
      {/* Floating Navigation */}
      <nav className="fixed top-6 left-1/2 transform -translate-x-1/2 z-50 bg-black/80 backdrop-blur-xl border border-yellow-500/30 rounded-full px-8 py-4 transition-all duration-500">
        <div className="flex items-center space-x-8">
          <div className="text-xl font-bold text-yellow-400" style={{ fontFamily: 'Cinzel Decorative, serif' }}>
            DLUXMEN
          </div>
          <div className="hidden lg:flex items-center space-x-6">
            <Link
              to="/"
              className="flex items-center space-x-2 text-xs font-medium transition-all cursor-pointer whitespace-nowrap px-3 py-2 rounded-full text-gray-300 hover:text-yellow-400 hover:bg-yellow-400/10"
            >
              <i className="ri-home-line"></i>
              <span>Início</span>
            </Link>
            <Link
              to="/apresentacao"
              className="flex items-center space-x-2 text-xs font-medium transition-all cursor-pointer whitespace-nowrap px-3 py-2 rounded-full text-gray-300 hover:text-yellow-400 hover:bg-yellow-400/10"
            >
              <i className="ri-play-circle-line"></i>
              <span>Experience</span>
            </Link>
            <Link
              to="/equipe"
              className="flex items-center space-x-2 text-xs font-medium transition-all cursor-pointer whitespace-nowrap px-3 py-2 rounded-full text-gray-300 hover:text-yellow-400 hover:bg-yellow-400/10"
            >
              <i className="ri-team-line"></i>
              <span>Team</span>
            </Link>
            <Link
              to="/produtos"
              className="flex items-center space-x-2 text-xs font-medium transition-all cursor-pointer whitespace-nowrap px-3 py-2 rounded-full text-black bg-yellow-400"
            >
              <i className="ri-fire-line"></i>
              <span>Produtos</span>
            </Link>
            <Link
              to="/contatos"
              className="flex items-center space-x-2 text-xs font-medium transition-all cursor-pointer whitespace-nowrap px-3 py-2 rounded-full text-gray-300 hover:text-yellow-400 hover:bg-yellow-400/10"
            >
              <i className="ri-phone-line"></i>
              <span>Contact</span>
            </Link>
          </div>
          <button
            onClick={() => window.open('https://wa.me/5511945589527?text=Olá!%20Quero%20conhecer%20os%20produtos%20DLUXMEN', '_blank')}
            className="bg-gradient-to-r from-green-600 to-green-500 hover:from-green-700 hover:to-green-600 text-white px-6 py-2 rounded-full text-sm font-semibold transition-all flex items-center space-x-2 whitespace-nowrap cursor-pointer shadow-lg shadow-green-500/25"
          >
            <i className="ri-whatsapp-line"></i>
            <span>WhatsApp</span>
          </button>
        </div>
      </nav>

      {/* Header */}
      <section className="pt-32 pb-16 bg-gradient-to-b from-black via-slate-900 to-black">
        <div className="container mx-auto px-6 text-center">
          <div className="inline-flex items-center bg-yellow-400/10 border border-yellow-400/30 rounded-full px-6 py-2 mb-8">
            <i className="ri-fire-line text-yellow-400 mr-2"></i>
            <span className="text-yellow-400 text-sm font-medium">PRODUTOS PREMIUM</span>
          </div>
          
          <h1 className="text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-300 mb-6" 
              style={{ fontFamily: 'Playfair Display, serif' }}>
            Catálogo DLUXMEN
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Explore nossa coleção premium de produtos de luxo
          </p>
        </div>
      </section>

      {/* Category Navigation */}
      <section className="sticky top-24 z-40 bg-black/90 backdrop-blur-xl border-y border-yellow-500/20 py-6">
        <div className="container mx-auto px-6">
          <div className="flex items-center justify-center space-x-4 overflow-x-auto">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                className={`flex items-center space-x-2 px-6 py-3 rounded-full transition-all whitespace-nowrap cursor-pointer ${
                  activeCategory === category.id
                    ? 'bg-yellow-400 text-black'
                    : 'text-gray-300 hover:text-yellow-400 hover:bg-yellow-400/10'
                }`}
              >
                <i className={`${category.icon} text-lg`}></i>
                <span className="font-medium">{category.name}</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-16 bg-gradient-to-b from-black via-slate-900 to-black min-h-screen">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {products[activeCategory as keyof typeof products]?.map((product, index) => (
              <div key={index} className="group relative">
                <div className="bg-gradient-to-br from-slate-800/30 to-slate-900/30 backdrop-blur-sm rounded-3xl overflow-hidden border border-yellow-500/10 hover:border-yellow-500/30 transition-all duration-500">
                  <div className="relative overflow-hidden">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-80 object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-4 right-4 bg-yellow-400 text-black px-3 py-1 rounded-full text-sm font-bold">
                      {product.line}
                    </div>
                    {product.badge && (
                      <div className="absolute top-4 left-4 bg-gradient-to-r from-red-600 to-red-500 text-white px-4 py-2 rounded-full text-sm font-bold">
                        {product.badge}
                      </div>
                    )}
                  </div>
                  
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-yellow-400 mb-2">{product.name}</h3>
                    <p className="text-emerald-400 font-semibold mb-1">{product.brand}</p>
                    {product.code && (
                      <p className="text-gray-400 text-sm mb-4">Código: {product.code}</p>
                    )}
                    <p className="text-gray-300 text-sm mb-6">{product.description}</p>

                    {/* Price Table */}
                    <div className="bg-black/30 rounded-lg p-4 mb-6">
                      <h4 className="font-semibold text-yellow-400 mb-3">Tabela de Preços</h4>
                      <div className="space-y-2 text-sm">
                        <div className="flex justify-between text-gray-300">
                          <span>1 peça:</span>
                          <span className="font-medium text-yellow-400">{product.prices.single}</span>
                        </div>
                        <div className="flex justify-between text-gray-300">
                          <span>3+ peças:</span>
                          <span className="font-medium text-yellow-400">{product.prices.three}</span>
                        </div>
                        <div className="flex justify-between text-gray-300">
                          <span>6+ peças:</span>
                          <span className="font-medium text-yellow-400">{product.prices.six}</span>
                        </div>
                        <div className="flex justify-between text-gray-300 border-t border-yellow-500/20 pt-2">
                          <span>12+ peças:</span>
                          <span className="font-bold text-yellow-400">{product.prices.twelve}</span>
                        </div>
                      </div>
                    </div>

                    <div className="space-y-3">
                      <button
                        onClick={() => window.open(`https://wa.me/5511945589527?text=Olá!%20Tenho%20interesse%20no%20${product.name}`, '_blank')}
                        className="w-full bg-gradient-to-r from-green-600 to-green-500 hover:from-green-700 hover:to-green-600 text-white py-3 rounded-lg font-medium transition-all flex items-center justify-center space-x-2 cursor-pointer"
                      >
                        <i className="ri-whatsapp-line text-lg"></i>
                        <span>Chamar no WhatsApp</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-white py-16 border-t border-yellow-500/20 relative overflow-hidden">
        <div className="container mx-auto px-6 relative z-10">
          <div className="text-center">
            <div className="text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-300 mb-6" 
                 style={{ fontFamily: 'Cinzel Decorative, serif' }}>
              DLUXMEN
            </div>
            <p className="text-gray-400 mb-12 text-lg">
              Experience Collection 2025 — Onde cada detalhe faz diferença.
            </p>
            
            <div className="flex flex-col md:flex-row items-center justify-between pt-8 border-t border-yellow-500/20">
              <p className="text-gray-400 mb-4 md:mb-0">
                © 2025 DLUXMEN. Todos os direitos reservados.
              </p>
              <a 
                href="https://readdy.ai/?origin=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-yellow-400 transition-colors text-sm"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ProdutosPage;
